const AccountGridComponent = {
    templateUrl: '/account/grid/accountGrid.tpl.html',
    controller: 'accountGridController',
    bindings: {
        isColumnFilterVisible: '<?',
        isGridFilterVisible: '<?',
        isViewActiveVisible: '<?',
        isSearchVisible: '<?',
        isGridPagingVisible: '<?',
        accounts: '<',
        submission: '<'
    }
};

angular.module('gw-um-submission')
    .component('uiAccountGrid', AccountGridComponent);
